import { zCustom } from '@nucleus/lib-shape';
import { yupKeyStringSchema, zKey } from '@nucleus/ncu-key-prefix';
import { ISO8601Schema } from '@nucleus/src-platform/data/date';
import * as yup from 'yup';
import { z } from 'zod';

export type PublishableEngine = z.infer<typeof PublishableEngineSchema>;

export const PublishableEngineSchema = z.object({
  id: zKey.prefixedKey(),
  ownerId: zKey.prefixedKey(),
  category: z.string().optional(),
  name: z.string().optional(),
  createdAt: zCustom.iso(),
  createdBy: z.string().trim(),
  updatedAt: zCustom.iso(),
  updatedBy: z.string().trim(),
  archivedAt: zCustom.iso().optional(),
  archivedBy: z.string().trim().optional(),
});

/**
 * @deprecated this schema is deprecated and will be removed in the future
 */
export const PublishableEngineSchemaDeprecated: yup.SchemaOf<PublishableEngine> = yup.object({
  id: yupKeyStringSchema.trim().required(),
  ownerId: yupKeyStringSchema.trim().required(),
  category: yup.string().trim(),
  name: yup.string().trim(),
  createdAt: ISO8601Schema.required(),
  createdBy: yup.string().trim().required(),
  updatedAt: ISO8601Schema.required(),
  updatedBy: yup.string().trim().required(),
  archivedAt: ISO8601Schema,
  archivedBy: yup.string().trim(),
});
